module.exports = "#myTable{\n\theight: 200px !important;\n}"